import { SortableTable, SortByConfig } from "components/Table/Table";
import { getSiteTableColumns } from "components/OverviewPages/getSiteTableColumns";

import { SiteOverview } from "interfaces/site-overview";
import { Row } from "react-table";

import { Paper } from "@mui/material";
import { useHistory } from "react-router";
import { styled } from "@mui/material/styles";
import { useEffect, useRef, useContext } from "react";
import { FeaturesContext } from "contexts/FeaturesContext";

export interface SiteTableProps {
  siteTableData: SiteOverview[];
  loading: boolean;
  selectedMachineName: string;
}

const SiteTableDefaultSort: SortByConfig[] = [
  {
    id: "name",
    desc: false
  }
];

export const SiteTable = ({
  siteTableData,
  loading,
  selectedMachineName
}: SiteTableProps): JSX.Element => {
  const history = useHistory();
  const { hasFeature } = useContext(FeaturesContext);

  const onRowClicked = (row: Row<SiteOverview>): void => {
    history.push(`/pages/machine/${row.original.id}`);
  };

  const scrollRef = useRef<HTMLDivElement | null>(null);
  const rowsRef = useRef<(HTMLTableRowElement | null)[]>([]);

  useEffect(() => {
    const rowIndex = siteTableData.findIndex(
      machine => machine.name === selectedMachineName
    );

    // get the offset from the top of the row selected minus the size of the sticky header
    const offsetTop = (rowsRef.current[rowIndex]?.offsetTop ?? 0) - 65;
    scrollRef.current?.scrollTo({ top: offsetTop, behavior: "smooth" });
  }, [selectedMachineName, siteTableData]);

  return (
    <SiteTableScroll ref={scrollRef} elevation={0}>
      <SortableTable
        data={siteTableData}
        columns={getSiteTableColumns(hasFeature)}
        onClickRow={onRowClicked}
        loading={loading}
        dataQa="site-table"
        isRowSelected={siteOverview =>
          siteOverview.name === selectedMachineName
        }
        defaultSortBy={SiteTableDefaultSort}
        rowsRef={rowsRef}
      />
    </SiteTableScroll>
  );
};

const SiteTableScroll = styled(Paper)`
  display: flex;
  flex-direction: column;
  flex-grow: 1;
  overflow: auto;
  margin: 24px;
  border: 1px solid rgba(224, 224, 224, 1);
  border-radius: 4px;
`;
